import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiCalendar} = FiIcons;

const ContentDate = ({
  published = '2025-08-19',
  updated = '2025-08-19',
  language = 'en',
  className = '',
}) => {
  const isChinese = language === 'zh-TW';
  const locale = isChinese ? 'zh-Hant-HK' : 'en-GB';
  const formatDate = (value) => new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(`${value}T00:00:00Z`));

  return (
    <div
      className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-sm text-gray-500 dark:text-gray-400 ${className}`}
      aria-label={isChinese ? '內容日期' : 'Content dates'}
    >
      <SafeIcon icon={FiCalendar} className="h-4 w-4" />
      <span>
        {isChinese ? '發布日期：' : 'Published: '}
        <time dateTime={published}>{formatDate(published)}</time>
      </span>
      <span aria-hidden="true">•</span>
      <span>
        {isChinese ? '更新日期：' : 'Updated: '}
        <time dateTime={updated}>{formatDate(updated)}</time>
      </span>
    </div>
  );
};

export default ContentDate;